import { ACTIONS } from '../types';
import STATUS from '../../../globalStatuses';

export const outlyingAreaReductions = {
  [ACTIONS.REQUEST_OUTLYING_AREAS]: state => ({
    ...state,
    outlyingAreasStatus: {
      ...state.outlyingAreasStatus,
      getStatus: STATUS.FETCHING,
      errorData: null,
    },
  }),
  [ACTIONS.RECEIVE_OUTLYING_AREAS]: (state, action) => ({
    ...state,
    outlyingAreas: {
      outlyingAreasUS: action.payload.outlyingAreasUS,
    },
    outlyingAreasStatus: {
      ...state.outlyingAreasStatus,
      getStatus: STATUS.FETCHED,
    },
  }),
  [ACTIONS.RECEIVE_OUTLYING_AREAS_ERROR]: (state, action) => ({
    ...state,
    error: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
    outlyingAreasStatus: {
      ...state.outlyingAreasStatus,
      getStatus: STATUS.ERROR,
      errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
    },
  }),
};

export default outlyingAreaReductions;
